import {
  updatePositionDrillsVideo,
  getPositionDrillsByUserEvent,
  deletePositionDrill,
  updatePositionDrillCoachingTip,
} from "../services/CombineService";
import {
  setLoadingCombine,
  setReload,
  setPositionDrill,
  setRemovePositionDrill,
  setAddPositionDrill,
  setUpdatePositionDrillCoachingTip,
  setPositions,
  setDrills,
} from "./slices/combineSlice";

const VIDEO_UPLOAD_TOAST_AUTO_CLOSE_MS = 3000;

export const getPositionDrillAction =
  (apiInstance, userId, eventId) => async (dispatch) => {
    dispatch(setLoadingCombine(true));
    try {
      const response = await getPositionDrillsByUserEvent(
        apiInstance,
        userId,
        eventId,
      );
      if (response.status === 200) {
        dispatch(setPositionDrill(response.data));
      }
    } catch (err) {
    } finally {
      dispatch(setLoadingCombine(false));
      dispatch(setReload(false));
    }
  };

export const savePositionDrillAction =
  (
    apiInstance,
    formData,
    toast,
    setLoadingVideo,
    data,
    resetForm,
    setUploadProgress,
  ) =>
  async (dispatch) => {
    try {
      const response = await updatePositionDrillsVideo(
        apiInstance,
        formData,
        setUploadProgress,
      );
      if (response.status === 200) {
        toast.success("Video uploaded successfully!", {
          autoClose: VIDEO_UPLOAD_TOAST_AUTO_CLOSE_MS,
        });
        dispatch(
          setAddPositionDrill({
            response: response.data,
            data: data,
          }),
        );
      }
    } catch (err) {
      toast.error("There was a problem uploading your video. Try Again", {
        autoClose: VIDEO_UPLOAD_TOAST_AUTO_CLOSE_MS,
      });
    } finally {
      setLoadingVideo(false);
      resetForm();
    }
  };

export const deletePositionDrillAction =
  (apiInstance, positionDrillId) => async (dispatch) => {
    try {
      await deletePositionDrill(apiInstance, positionDrillId);
      dispatch(setRemovePositionDrill(positionDrillId));
    } catch (err) {
      console.error(err);
    }
  };

export const savePositionDrillCoachingTipAction =
  (apiInstance, positionDrillId, coachingTip) => async (dispatch) => {
    try {
      const response = await updatePositionDrillCoachingTip(
        apiInstance,
        positionDrillId,
        coachingTip,
      );

      dispatch(
        setUpdatePositionDrillCoachingTip({
          id: positionDrillId,
          coachingTip,
        }),
      );

      return response;
    } catch (err) {
      throw err;
    }
  };

export const getPositionsAction = (apiInstance) => async (dispatch) => {
  try {
    const response = await apiInstance.get(`/Combine/positions`);
    if (response.status === 200) {
      dispatch(setPositions(response.data));
    }
  } catch (err) {
    console.error(err);
  }
};

export const getDrillsAction =
  (apiInstance, positionId, setLoadingDrills) => async (dispatch) => {
    try {
      const response = await apiInstance.get(
        `/Combine/drill-by-position/${positionId}`,
      );
      if (response.status === 200) {
        dispatch(setDrills(response.data));
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingDrills(false);
    }
  };
